export const ETSY_SHOP = "https://www.etsy.com/shop/DreamFreeStudio";

export const SOCIALS = {
  etsy: ETSY_SHOP,
  youtube: "https://www.youtube.com/channel/UCt4VDYRnN8axvLh1gJF4vzQ",
  tiktok: "https://www.tiktok.com/@dreamfreestudio",
};

export const MANIFESTO = [];

export const COLLECTIONS = [
  {
    name: "Everyday Happiness",
    pieces: "Totes, backpacks & clear stadium bags · bento boxes · decals, sticky notes & everyday tech",
    span: "md:col-span-7",
    bg: "bg-blush",
    slug: "everyday-happiness",
  },
  {
    name: "Personal Growth",
    pieces: "Journals & notebooks — spiral, softcover and hardcover",
    span: "md:col-span-5",
    bg: "bg-lavender",
    slug: "personal-growth",
  },
  {
    name: "Good Things",
    pieces: "Tumblers, mugs & sipper glasses · golf balls · photo puzzles",
    span: "md:col-span-4",
    bg: "bg-sage/60",
    slug: "good-things",
  },
  {
    name: "Presence",
    pieces: "Blankets & comforters · night lights · posters, photo blocks & wall decor",
    span: "md:col-span-4",
    bg: "bg-cream",
    slug: "presence",
  },
  {
    name: "Beach & Summer",
    pieces: "Swimwear & beach bags · water bottles, tumblers & speakers · travel gear",
    span: "md:col-span-4",
    bg: "bg-blush",
    slug: "beach-summer",
  },
  {
    name: "Wear Your Joy",
    pieces: "Tees, tanks & hoodies · shorts, skorts & sweats · caps, pajamas & polos",
    span: "md:col-span-6",
    bg: "bg-lavender",
    slug: "wear-your-joy",
  },
  {
    name: "Little Luxuries",
    pieces: "Bracelets, necklaces & rings · jewelry boxes & makeup bags · flasks & gift wrap",
    span: "md:col-span-6",
    bg: "bg-sage/60",
    slug: "little-luxuries",
  },
];

export const SETS = [
  {
    id: "backpacks",
    title: "Backpacks",
    line: "Casual, clear, stadium-approved or diaper-duty — every carry, one good word. Sold individually, styled together.",
    bg: "bg-blush",
    inverse: false,
    items: [
      { name: "Casual Shoulder Backpack" },
      { name: "Clear Backpack" },
      { name: "Clear Stadium Backpack" },
      { name: "Diaper Backpack" },
      { name: "Holographic Backpack", detail: "See-through shimmer that catches the sun — currently being sourced with our print partner." },
    ],
  },
  {
    id: "water-bottles",
    title: "Water Bottles",
    line: "Mini, slim or sport — hydration with a reminder attached. Pick your size, or collect all three.",
    bg: "bg-lavender",
    inverse: false,
    items: [
      { name: "Mini Water Bottle" },
      { name: "Slim Water Bottle" },
      { name: "Sport Bottle — 20oz Tritan", match: "Make Today Amazing Water Bottle", detail: "The gym-and-trail size of the trio, in shatter-resistant Tritan." },
    ],
  },
  {
    id: "notebooks-journals",
    title: "Notebooks & Journals",
    line: "Spiral for lists, softcover for thoughts, hardcover for keeps — give your 3am ideas somewhere good to go.",
    bg: "bg-cream",
    inverse: false,
    items: [
      { name: "Spiral Notebook" },
      { name: "Softcover Journal" },
      { name: "Hardcover Journal" },
    ],
  },
  {
    id: "swimwear",
    title: "Swimwear",
    line: "Bikini or trunks, same good word — made to be worn as a matching pair or on their own.",
    bg: "bg-blush",
    inverse: false,
    items: [
      { name: "Bikini Swimsuit" },
      { name: "Swim Trunks" },
    ],
  },
  {
    id: "fruit-of-the-spirit-jewelry",
    title: "Fruit of the Spirit Jewelry",
    line: "Rings, bracelets and necklaces that carry the nine — stack them, gift them, keep them close. Each sold individually.",
    bg: "bg-sage/60",
    inverse: false,
    items: [
      { name: "Fruit of the Spirit Ring Set", detail: "Nine stacking rings — love, joy, peace, patience, kindness, goodness, faithfulness, gentleness, self-control. Currently being sourced." },
      { name: "Heart Signet Ring" },
      { name: "Heart Cuff Bracelet" },
      { name: "Leather Bracelet with Beads" },
      { name: "Natural Stone Stretch Bracelet" },
      { name: "Paperclip Heart Bracelet" },
      { name: "Bangle Cuff Bracelet" },
      { name: "Heart Necklace" },
      { name: "Paperclip Heart Necklace" },
    ],
  },
  {
    id: "ties-cufflinks",
    title: "Ties & Cufflinks",
    line: "For weddings, work and the clubhouse — the finishing touches that make your presence count.",
    bg: "bg-navy",
    inverse: true,
    items: [
      { name: "Necktie" },
      { name: "Cufflinks" },
    ],
  },
  {
    id: "blankets",
    title: "Blankets & Bedding",
    line: "Velvet, sherpa and full comforters — good things you can literally wrap yourself in.",
    bg: "bg-cream",
    inverse: false,
    items: [
      { name: "Crushed Velvet Blanket" },
      { name: "Fleece Sherpa Blanket" },
      { name: "Comforter" },
    ],
  },
  {
    id: "drinkware",
    title: "Drinkware",
    line: "Tumblers, sipper glasses, mugs and flasks — the reminder, right at your lips.",
    bg: "bg-lavender",
    inverse: false,
    items: [
      { name: "Chill Wine Tumbler" },
      { name: "Sipper Glass with Straw" },
      { name: "Sunsplash Tumbler with Straw" },
      { name: "Heart-Shaped Mug" },
      { name: "Stainless Steel Flask" },
    ],
  },
  {
    id: "apparel",
    title: "Apparel",
    line: "Tees, tanks, hoodies, shorts, sweats and sleep — wear your joy, literally. New variations land as they list.",
    bg: "bg-sage/60",
    inverse: false,
    fromCollection: "Wear Your Joy",
    items: [],
  },
];

export const BUNDLES = [
  {
    id: "everyday-carry",
    title: "The Everyday Carry",
    line: "A backpack, a journal and a bottle walk into your best day.",
    items: [
      { name: "Casual Shoulder Backpack" },
      { name: "Spiral Notebook" },
      { name: "Mini Water Bottle" },
    ],
    parts: [
      { label: "Backpacks", to: "/sets/backpacks" },
      { label: "Notebooks & Journals", to: "/sets/notebooks-journals" },
      { label: "Water Bottles", to: "/sets/water-bottles" },
    ],
    bg: "bg-blush",
    inverse: false,
  },
  {
    id: "beach-day",
    title: "The Beach Day",
    line: "Swim, sip, repeat — the trio that turns a Tuesday into a vacation.",
    items: [
      { name: "Woven Straw Tote Bag" },
      { name: "Bikini Swimsuit" },
      { name: "Swim Trunks" },
      { name: "Slim Water Bottle" },
    ],
    parts: [
      { label: "Swimwear", to: "/sets/swimwear" },
      { label: "Water Bottles", to: "/sets/water-bottles" },
      { label: "Beach & Summer", to: "/collections/beach-summer" },
    ],
    bg: "bg-lavender",
    inverse: false,
  },
  {
    id: "sweet-dreams",
    title: "Sweet Dreams",
    line: "Pajamas, a blanket and a night light — the bedtime ritual, built piece by piece.",
    items: [
      { name: "Satin Pajama Set" },
      { name: "Crushed Velvet Blanket" },
      { name: "Custom Shape Night Light" },
    ],
    parts: [
      { label: "Apparel", to: "/sets/apparel" },
      { label: "Blankets & Bedding", to: "/sets/blankets" },
      { label: "Presence", to: "/collections/presence" },
    ],
    bg: "bg-navy",
    inverse: true,
  },
  {
    id: "the-fairway",
    title: "The Fairway",
    line: "Polo, tie, tumbler — for the course, the clubhouse and the toast.",
    items: [
      { name: "Dri-Mesh V-Neck Polo" },
      { name: "Necktie" },
      { name: "Golf Balls, Set of 6" },
      { name: "Chill Wine Tumbler" },
    ],
    parts: [
      { label: "Ties & Cufflinks", to: "/sets/ties-cufflinks" },
      { label: "Drinkware", to: "/sets/drinkware" },
      { label: "Apparel", to: "/sets/apparel" },
    ],
    bg: "bg-cream",
    inverse: false,
  },
];

export const DOLLY_QUOTES = [
  "The way I see it, if you want the rainbow, you gotta put up with the rain.",
  "Find out who you are and do it on purpose.",
  "If you see someone without a smile, give 'em yours.",
  "Storms make trees take deeper roots.",
  "Dream more, learn more, care more, and be more.",
  "If you don't like the road you're walking, start paving another one.",
  "We cannot direct the wind, but we can adjust the sails.",
  "You'll never do a whole lot unless you're brave enough to try.",
];

export const slug = (s) =>
  s.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
